<template>
  <div>
    <el-dialog
      title="红色框标注为已改的旧数据"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false" top="5vh" width="1200px">
      <component :is="form_type" :form_data="form" :form_old_data="form_old" v-if="dialogVisible"></component>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "customer-preview",
  components: {
    "enterprise-preview": () => import("./enterprise-preview.vue"),
    "family-document-preview": () => import("./family-document-preview.vue"),
    "other-preview": () => import("./other-preview.vue"),
    "personal-basic-preview": () => import("./personal-basic-preview.vue"),
    "personal-extend-preview": () => import("./personal-extend-preview.vue"),
  },
  data() {
    return {
      dialogVisible: false,
      form: {},
      form_old: {},
      form_type:""
    };
  },
  methods: {
    show(data={}){
      this.form = data.form_after||{};
      this.form_old = data.form_before||{};
      this.form_type = data.form_type||'';
      this.dialogVisible = true;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/components/preview/customer-preview.vue